import {
    dashboardCount,
    getKpiData,
    getTableData,
    getCustomTableData,
    bookingCount,
    fetchCompleteDashboardData
} from '../../pages/supDashboard/supDashboardFun/fetchDashboardData';
import { getOrganizers } from '../getOrganizers';

const commonBaseAPIServiceConfig = {
    fetchOrg: ({ serviceType, setOrgData, setLoading }) => {
        return getOrganizers(serviceType, setOrgData, setLoading);
    },
    fetchCount: async ({ selectedOrg, selected, setTotalCount, setLoading, serviceType }) => {
        return bookingCount(setTotalCount, setLoading, selectedOrg, '', '', selected, '', '', serviceType);
    },
    fetchKpi: async ({ setKpiData, setLoading, selectedOrg, serviceType }) => {
        getKpiData(setKpiData, setLoading, selectedOrg, serviceType);
    },
    fetchTable: async ({
        orgId,
        setTableData,
        setTotalCount,
        setKpiData,
        bookingsOnly,
        limit,
        offSet,
        selected,
        setLoading,
        datesType,
        serviceType
    }) => {
        return await fetchCompleteDashboardData(
            serviceType,
            orgId,
            setTableData,
            setTotalCount,
            setKpiData,
            bookingsOnly,
            limit,
            offSet,
            selected,
            setLoading,
            datesType,
            '',
            ''
        );
    }
};

export const dashboardServiceConfig = {
    trip: {
        fetchOrg: ({ serviceType, setOrgData, setLoading }) => {
            return getOrganizers(serviceType, setOrgData, setLoading);
        },
        fetchCount: async ({ selectedOrg, selected, setTotalCount, setLoading }) => {
            return dashboardCount(selectedOrg, selected, setTotalCount, setLoading);
        },
        fetchKpi: async ({ setKpiData, setLoading, selectedOrg, serviceType }) => {
            getKpiData(setKpiData, setLoading, selectedOrg, serviceType);
        },
        fetchTable: async ({ orgId, setTableData, limit, offSet, selected, setLoading, datesType, bookingsOnly }) => {
            if (datesType === 'custom') {
                return await getCustomTableData(orgId, setTableData, limit, offSet, selected, setLoading, datesType);
            } else {
                return getTableData(orgId, selected, setTableData, limit, offSet, setLoading, bookingsOnly);
            }
        }
    },
    gu: commonBaseAPIServiceConfig,
    act: commonBaseAPIServiceConfig,
    // camp / stay: check-ins (GET /org/dashboard/camp/:orgId, same response shape)
    camp: commonBaseAPIServiceConfig
};
